<template>
  <div
    class="m-uploader"
    tabindex="0"> <!-- TODO Pass focus to input for accessiblity -->
    <div class="m-uploader__contents">
      <b>Click or drag to upload...</b>
      <p v-for="(file, index, key) in files" :key="key">
        {{ index + 1 }}. {{ file.name }} <span v-if="progress[index]">
          ({{ progress[index] }}% Uploaded)
        </span>
      </p>
    </div>
    <input
      class="m-uploader__input"
      type="file"
      ref="uploader"
      @change="onChange"
      :multiple="multiple"
      :accept="accept" />
  </div>
</template>

<script>

export default {
  name: 'v-uploader',
  props: {
    options: {
      required: true,
      type: [Object],
    },
    multiple: {
      required: false,
      type: [Boolean],
    },
    loading: {
      required: false,
      type: [Boolean],
    },
    driver: {
      required: true,
      type: [Function],
    },
    accept: [String],
  },
  data() {
    return {
      files: [],
      progress: [],
    };
  },
  methods: {
    onChange() {
      const formData = new FormData();
      if (this.multiple === false) {
        this.files.shift();
        this.files.push(this.$refs.uploader.files[0]);
      } else {
        this.files = this.files.push(...this.$refs.uploader.files);
      }

      formData.append('logo', this.files[0]);

      this.driver({
        method: this.options.method,
        url: this.options.url,
        contentType: this.options.contentType || 'application/json',
        data: formData,
        progressEvent: (response) => {
          this.progress.pop();
          this.progress.push(Math.floor((response.loaded / response.total) * 100));
        },
      }).then((response) => {
        console.log(response);
        this.$emit('updated', response.data.data.logo);
        return response.data;
      }).catch((error) => {
        throw error;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/component-utils';

  $parent: '.m-uploader';

  #{$parent} {
    border: 2px dashed $signable-primary-1;
    border-radius: 8px;
    position: relative;
    padding: 10px;
    cursor: pointer;
    &__contents {
      cursor: pointer;
    }
    &__input {
      opacity: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      cursor: pointer;
    }
  }
</style>
